import type { Router } from "@/typeDefinitions/custom/Router";

const router: Router.LicensedRouterExportType = [
  {
    path: "/powerBITemplates",
    name: "PowerBiTemplates",
    meta: {
      rights: ["sqdc.admin"],
    },
    children: [
      {
        name: "PowerBiTemplatesList",
        path: "",
        component: () => import("./views/PowerBITemplates.vue"),
        meta: {
          rights: ["sqdc.admin"],
        },
      },
      {
        name: "PowerBiTemplateCreate",
        path: "create",
        component: () => import("./views/PowerBITemplateCreate.vue"),
        meta: {
          rights: ["sqdc.admin"],
        },
      },
      {
        name: "PowerBiTemplateUpdate",
        path: ":id",
        component: () => import("./views/PowerBITemplateUpdate.vue"),
        props: (route) => ({ id: Number(route.params.id) }),
        meta: {
          rights: ["sqdc.admin"],
        },
      },
    ],
  },
];

export default router;
